<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="userlogs">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm11 md8 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="teal darken-3">
                        <v-toolbar-title><v-icon color="white">mdi-text-search</v-icon>&nbsp;Actividad de Usuarios</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items class="hidden-sm-and-down">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn text @click="onClose" v-on="on">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cerrar</span>
                            </v-tooltip>
                        </v-toolbar-items>

                        <!-- Menú lateral para dispositivos con ventanas chicas: -->
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" class="hidden-md-and-up">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list color="grey lighten-5">

                                <v-list-item @click="onClose">
                                    <v-list-item-title>
                                        <v-icon color="red">mdi-close</v-icon>&nbsp; Cerrar
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>

                    <!-- Container principal: -->
                    <v-container pa-2 grid-list-md>
                        <!-- Renglón principal: -->
                        <v-layout row wrap justify-space-around>
                            <v-flex xs12>
                                <v-card color="grey lighten-5">
                                    <v-card-text>
                                        <v-container fluid>
                                            <v-layout row>
                                                <v-flex xs7>
                                                    <v-text-field
                                                        color="cyan darken-4"
                                                        prepend-icon="mdi-email"
                                                        name="email"
                                                        label="Correo electrónico"
                                                        type="email"
                                                        v-model="email"
                                                        :rules="emailRules"
                                                        required
                                                        align-self-center
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs2>
                                                    <v-btn
                                                        @click="onSearch"
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                    >Buscar</v-btn>
                                                </v-flex>
                                                <v-flex xs2>
                                                    <v-btn
                                                        @click="onCleanResults"
                                                        color="pink darken-3"
                                                        class="text-none"
                                                        text
                                                    >Limpiar resultados</v-btn>
                                                </v-flex>
                                            </v-layout>    
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-card>
                                    <v-toolbar
                                        dense
                                        color="teal lighten-3"
                                        flat
                                    >
                                        <v-toolbar-title class="my-list-title">&nbsp; {{ logTitle }}</v-toolbar-title>                           
                                    </v-toolbar>
                                    <v-data-table
                                        fixed-header
                                        :headers="userActivityHeader"
                                        :items="userActivityLogs"
                                        height="280"
                                        item-key="actividadid"
                                        v-model="selectedLog"
                                        locale="es-MX"
                                        :hide-default-footer="userActivityLogs.length < 11"
                                        :show-select=false
                                        dense
                                        no-data-text=""
                                        :items-per-page="10"
                                        :footer-props="{
                                            'items-per-page-text':'Registros por página:',
                                            'items-per-page-all-text':'Todos',
                                        }"
                                    >
                                    </v-data-table>     
                                </v-card>
                            </v-flex>
                        </v-layout>

                        <!-- Modal para informar que no hubo resultados en la búsqueda: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bShowNotFoundAlert" persistent max-width="30%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title">Actividad de usuario</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >El usuario buscado no tiene actividad registrada.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bShowNotFoundAlert = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para informar que no hubo resultados en la búsqueda *************************** -->

                        <!-- Modal para informar que los datos no son válidos: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bInvalidData" persistent :width="errorModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title">Información no Válida</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                    >mdi-alert-circle</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center text-center"
                                                >{{ errorMessage }}</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bInvalidData = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para informar que los datos no son válidos *********************************** -->
                        

                        
                    </v-container>
                    <!-- Termina container para lista de idiomas e idioma seleccionado -->
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>

        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'UserLogs',
    data() {
        return {
            drawer: false,
            bInvalidData: false,
            errorMessage: '',
            email: '',
            user: '',
            emailRules: [
                (v) => !!v || 'Introduzca el correo electrónico del usuario',
                (v) =>
                    /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                    'Introduzca un correo válido',
            ],
            
            bShowNotFoundAlert: false, //Indica si se debe mostrar el diálogo que indica que no hubo resultados en la búsqueda.

            userActivityHeader: [
                {
                    text: 'Fecha',
                    value: 'fechainicio',
                    sortable: true,
                    width: '20%',
                    align: 'left',
                    divider: true,
                },
                {
                    text: 'Actividad',
                    value: 'accion',
                    sortable: true,
                    width: '20%',
                    align: 'left',
                    divider: true,
                },
                {
                    text: 'Sistema Operativo',
                    value: 'so',
                    sortable: true,
                    width: '20%',
                    align: 'left',
                    divider: true,
                },
                {
                    text: 'Navegador',
                    value: 'navegador',
                    sortable: true,
                    width: '20%',
                    align: 'left',
                    divider: true,
                },
                {
                    text: 'Dirección IP',
                    value: 'ip',
                    sortable: true,
                    width: '20%',
                    align: 'left',
                    divider: true,
                },
            ],
            selectedLog: [],
        };
    },
    components: {},
    created() {
        
    },
    methods: {
        onClose() {
            this.onCleanResults();
            this.$router.push('/').catch(err => {});
        },

        onSearch()
        {
            if (this.email === "")
            {
                this.bInvalidData = true;
                this.errorMessage = "Teclee el correo electrónico del usuario.";
            }
            else
            {
                this.user = this.email;
                this.$store.dispatch('fetchUserLogs', this.email);
            }
        },

        onCleanResults() {
            this.email = '';
            this.user = '';
            this.userActivityLogs = [];
        },
        
    },
    computed: {
        ...mapGetters(['waitCursor',]),

        userActivityLogs: {
            get() {
                return this.$store.getters.userActivityLogs;
            },
            set(userActivityLogs) {
                this.$store.dispatch('updateUserActivityLogs', userActivityLogs);
            },
        },
        
        logTitle()
        {
            var strTitle = 'Actividad del usuario ' + this.user;
            return strTitle;
        },

        listHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '100px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '200px';
            } else {
                height = '300px';
            }
            return height;
        },

        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '20%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '10%';
            }
            return width;
        },

        logoHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '50';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '60';
            } else if (this.$vuetify.breakpoint.md) {
                height = '70';
            } else if (this.$vuetify.breakpoint.lg) {
                height = '80';
            } else {
                height = '100';
            }
            return height;
        },
    }
};
</script>

<style scoped>
.sub-window {
    /* background-color: #e0e0e0; */
    /*grey lighten-2 */
    background: rgba(224, 224, 224, 0.6);
}
.userlogs {
    background: url('../assets/alex-kotliarskyi-QBpZGqEMsKg-unsplash.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>